

import { Box, Avatar } from "@chakra-ui/react"
import React, { useState } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import { ImageDimensions } from "./LazyHelpers";

const LazyImg = LazyLoadImage as React.ComponentType<React.PropsWithChildren<Record<string, unknown>>>;


const LazyAvatar = (props: any) => {

    const { src, width, height, ...rest } = props


    const [imageRatio, setImageRatio] = useState(1)

    // const scalingFactor = calculateScalingFactor(width, height,
    //     (imageRatio > 1) ?  width * imageRatio : width, 
    //     (imageRatio < 1) ? height * ( 1 / imageRatio) : height
    // )



    const finalWidth = (true) ? imageRatio * height : imageRatio * width


    return <>
        <ImageDimensions src={src} setImageRatio={setImageRatio} />


        <Box {...rest} width={`${width}px`} height={`${height}px`} minW={`${width}px`}
            position="relative" borderRadius="50%"
            overflow={"hidden"}
        >
            {(src == "" || src == null) ? <Avatar w="100%" h="100%" minW="100%" /> : <>
                <LazyImg
                    src={src}
                    style={{
                        position: 'absolute',
                        top: "0",
                        left: "0",
                        minWidth: `${finalWidth}px`,
                    }}
                    effect="opacity"
                />
            </>}
        </Box>

    </>
}


export default LazyAvatar